import {buildQueryAndVariablesHash} from 'src/internal/revamp/queryUtils/queryAndVariablesHashing';

import type {DocumentNode} from 'graphql';
import type {OperationVariables} from 'src/internal/revamp/graphql/types';

/**
 * Returns a stable string identifying a GraphQL operation together with its
 * variables. Two calls with an equivalent document and variables produce the
 * same hash, which makes it suitable as a `PerformanceMonitor` track key.
 */
export default function hashGraphQlOperation(
  document: DocumentNode,
  variables: OperationVariables | undefined,
): string {
  return buildQueryAndVariablesHash(document, variables)
    .documentHashWithVariables;
}
